var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2477",
    "data-name": "Group 2477",
    transform: "translate(379 -4736)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1580",
    "data-name": "Rectangle 1580",
    width: 15,
    height: 15,
    transform: "translate(-379 4736)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2462",
    "data-name": "Group 2462",
    transform: "translate(-379 4736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1915",
    "data-name": "Group 1915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1914",
    "data-name": "Group 1914"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_908",
    "data-name": "Rectangle 908",
    width: 6.667,
    height: 5,
    transform: "translate(8.333)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_909",
    "data-name": "Rectangle 909",
    width: 6.667,
    height: 8.333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_910",
    "data-name": "Rectangle 910",
    width: 6.667,
    height: 5,
    transform: "translate(0 10)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_911",
    "data-name": "Rectangle 911",
    width: 6.667,
    height: 8.333,
    transform: "translate(8.333 6.667)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.0bdb495e0c384c87204d2d53bd12db50.svg";
export { ForwardRef as ReactComponent };